import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, Button, Box } from "@mui/material";
import checkIcon from "../../assets/icons/check.png";
import errorIcon from "../../assets/icons/error.png";
import { clearFormData } from "../../redux/actions/UserActions";
import { useDispatch, useSelector } from 'react-redux'

const SuccessScreen = ({ status = "success", errorMessage = "", onRetry }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const handleNext = () => {
        if (status === "success") {
            navigate("/"); // Navigate to Home Page
            dispatch(clearFormData())
        } else {
            navigate("/register"); // Navigate to Step 1
        }
    };
    return (
        <Container
            maxWidth="xs"
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "70vh",
                textAlign: "center",
                px: 3,
            }}
        >
            {/* Success or Failure Icon */}
            <Box sx={{ mb: 3 }}>
                <img
                    src={status === "success" ? checkIcon : errorIcon} // Failure icon (replace if needed)
                    alt={status === "success" ? "Success" : "Error"}
                    style={{ width: 300, height: 300 }}
                />
            </Box>

            {/* Title */}
            <Typography variant="h5" fontWeight="bold">
                {status === "success" ? "Success!" : "Error!"}
            </Typography>

            {/* Message */}
            <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
                {status === "success"
                    ? "You have registered to this event!"
                    : errorMessage || "Something went wrong, please try again."}
            </Typography>

            {/* Styled Button */}
            <Button
                variant="contained"
                fullWidth
                sx={{
                    bgcolor: status === "success" ? "#1976d2" : "#d32f2f",
                    color: "white",
                    borderRadius: "50px",
                    height: 50,
                    fontSize: "16px",
                    fontWeight: "bold",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    "&:hover": {
                        bgcolor: status === "success" ? "#1565c0" : "#b71c1c",
                    },
                }}
                onClick={handleNext}
            >
                {status === "success" ? "Next" : "Retry"}
            </Button>
        </Container>
    );
};

export default SuccessScreen;
